import { IHttpClient } from "../../../lib/http";
import { UpgradeConfigurationDto } from "../domain/upgradeConfiguration.schema";
import { UpgradeConfigurationEntity } from "../domain/upgradeConfiguration.entity";

export interface Paginated<T> {
  total: number;
  limit: number;
  skip: number;
  data: T[];
}

export async function findUpgradeConfiguration(
  httpClient: IHttpClient,
  propertyTicker: string
): Promise<UpgradeConfigurationEntity[]> {
  const dtoPage: Paginated<UpgradeConfigurationDto> = await httpClient.get<
    Paginated<UpgradeConfigurationDto>
  >(`/selling-configuration/property/${propertyTicker}`);
  return dtoPage.data.map(dto => UpgradeConfigurationEntity.of(dto));
}

export async function getUpgradeConfiguration(
  httpClient: IHttpClient,
  id: string
): Promise<UpgradeConfigurationEntity> {
  const dto: UpgradeConfigurationDto = await httpClient.get<UpgradeConfigurationDto>(
    `/selling-configuration/${id}`
  );
  return UpgradeConfigurationEntity.of(dto);
}

export async function createUpgradeConfiguration(
  httpClient: IHttpClient,
  entity: UpgradeConfigurationEntity
): Promise<void> {
  await httpClient.post(`/selling-configuration`, entity.toDto());
}

export async function updateUpgradeConfiguration(
  httpClient: IHttpClient,
  id: string,
  entity: UpgradeConfigurationEntity
): Promise<void> {
  await httpClient.put(`/selling-configuration/${id}`, entity.toDto());
}

export async function deleteUpgradeConfiguration(
  httpClient: IHttpClient,
  id: string
): Promise<void> {
  await httpClient.delete(`/selling-configuration/${id}`);
}
